import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import { createStore , combineReducers , applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import productsReducer from './store/reducers/products';
import cartReducer from './store/reducers/cart';
import ordersReducer from './store/reducers/orders';

import { AuthContextProvider } from './store/auth-context';
import { ThemeContextProvider } from './store/theme-context';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootReducer = combineReducers( {
  prod: productsReducer,
  cart: cartReducer,
  orders: ordersReducer,
} );

const logger = store => {
  return next => {
      return action => {
          //console.log('[Middleware] Dispatching', action);
          const result = next(action);
          //console.log('[Middleware] next state', store.getState());
          return result;
      }
  }
};

const composeEnhancers =   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__  || compose;

const store = createStore( rootReducer , composeEnhancers( applyMiddleware( logger, thunk ) ) );

const app = (
  <Provider store={store}>
      <AuthContextProvider>
        <BrowserRouter>
          <ThemeContextProvider>
            <App />
          </ThemeContextProvider >
        </BrowserRouter>
      </AuthContextProvider>  
    </Provider>
  )

  ReactDOM.render(app, document.getElementById('root') );
  
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
